angular.module('unica_wiki.wiki_services')

.factory('WikiEditService', function ($http, getBaseApiURL) {

	var wikiEditService = {};

	wikiEditService.update = function (wikiData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/wiki/update/' + wikiData.id,
			data: wikiData
		}).then(function(result) {

			if ( result ) {
				return result.data.changelog;
			}

		});
	};

	wikiEditService.deleteImage = function (wikiData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/wiki/remove-image/' + wikiData.id,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.changelog;
			}

		});
	};

	return wikiEditService;
});